export default "__VITE_ASSET__DoWIU7MX__"